export const StrategiesModal = 'StrategiesModal';
export const GET_STRATEGY_MODAL_DATA = 'GET_STRATEGY_MODAL_DATA';
